import React, { useEffect, useState } from 'react'
import { useContactStore } from '../../store/useContactStore'
import Loader from '../../Components/Loader'


export default function ContactInfo() {

  const [data, setData] = useState({
    phoneNumber: '',
    email: '',
    facebookLink: '',
    address: '',

  })
  const [loading, setLoading] = useState(false)
  const { getContact, contact, postContact } = useContactStore()

  const getContactInfo = async () => {
    setLoading(true)
    await getContact()
    setLoading(false)
  }

  const handleSubmit = async () => {
    setLoading(true)
    await postContact(data)
    setLoading(false)
  }


  useEffect(() => {
    if (!contact)
      getContactInfo()
    else {
      setData({
        phoneNumber: contact?.phoneNumber,
        email: contact?.email,
        facebookLink: contact?.facebookLink,
        address: contact?.address,
      })
    }
  }, [contact])

  return (
    <div id="contact-info-section" className="bg-white rounded-md shadow-sm border border-neutral-200 overflow-hidden mb-6">
      <div className="px-6 py-4 border-b border-neutral-200 bg-neutral-50">
        <h3>Contact Information</h3>
      </div>

      <Loader loading={loading}>
        <div className="p-6">
          <div className="grid grid-cols-2 gap-6">
            <div className="space-y-4">
              <div>
                <label className="block text-sm text-neutral-700 mb-2">Phone Number</label>
                <input type="text"
                  value={data?.phoneNumber}
                  onChange={(e) => setData({ ...data, phoneNumber: e.target.value })} className="w-full p-3 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400" />
              </div>
              <div>
                <label className="block text-sm text-neutral-700 mb-2">Email Address</label>
                <input
                  type="email"
                  value={data?.email}
                  onChange={(e) => setData({ ...data, email: e.target.value })}
                  className="w-full p-3 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400" />
              </div>

            </div>

            <div className="bg-white rounded-md shadow-sm border border-neutral-200 overflow-hidden">
              <div className="px-6 py-4 border-b border-neutral-200 bg-neutral-50 flex justify-between items-center">
                <h3>Social Media</h3>

              </div>
              <div className="p-6 space-y-3">
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-neutral-100 rounded-md flex items-center justify-center mr-3">
                    <i className="fa-brands fa-facebook-f text-neutral-700"></i>
                  </div>
                  <input type="text"
                    value={data?.facebookLink}
                    onChange={(e) => setData({ ...data, facebookLink: e.target.value })}
                    className="flex-1 p-2 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400" />

                </div>
              </div>
            </div>
          </div>
          <div className="mt-6 mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-1">Address</label>
            <textarea rows="3"
              value={data?.address}
              onChange={(e) => setData({ ...data, address: e.target.value })}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500">

            </textarea>
          </div>
        </div>
      </Loader>

      <div className='p-6 flex justify-end'
        onClick={() => handleSubmit()}>
        <button className="bg-neutral-900 text-white px-4 py-2 rounded-md text-sm flex items-center">
          <i className="fa-solid fa-save mr-2"></i>
          Save Changes
        </button>
      </div>
    </div>

  )
}
